
import _, { cloneDeep } from 'lodash-es'

export default {
  data() {
    return {
      //实例对象
      fApi: {},
      //表单数据
      value: {},
      //表单生成规则
      rule: [],
      //组件参数配置
      option: {
        //表单提交事件
        onSubmit: function (formData) {
          console.log(JSON.stringify(formData))
        },
        // 隐藏提交按钮
        submitBtn: false,
        // element-ui 表单配置
        form: {
          size: 'small'
        }
      },
      submitBtn: false,
      resetBtn: false
    }
  },
  methods: {
    handleOpen() {
      // 打开时初始化组件状态
      this.$store.commit('editor/disableHover');
      this.rule = cloneDeep(this.$store.state.editor.editFormDialog.rule);

    },
    handleConfirm() {
      this.$store.commit('editor/hideEditFormDialog');
      this.$store.state.editor.editFormDialog.onConfirm(this.value);
    },
    handleClose() {
      this.$store.commit('editor/enableHover');
    }
  }
}
